export const MOCK_FAMILY_LIST = [
  {
    no: "1",
    name: "Thirawat Wat...",
    relationship: "Father",
    dateOfBirth: "08/01/1970",
    career: "รับจ้าง",
    phoneNo: "+66865053836",
  },
];

export const MOCK_WORK_EXPERIENCE_LIST = [
  {
    no: "1",
    position: "Front End Dev.",
    company: "PTT",
    salary: "75,000 THB",
    startDate: "01/01/2023",
    endDate: "01/01/2024",
  },
];

export const MOCK_EDUCATION_LIST = [
  {
    no: "1",
    institute: "KMITL",
    educationDegree: "Bachelor's Degree",
    graduatedFrom: "Local",
    faculty: "Science",
    majorSubject: "Mathematics",
    gpax: "3.87",
    startDate: "01/01/2023",
    endDate: "01/01/2024",
  },
];

export const MOCK_SHIFT_LIST = [
  {
    no: "1",
    workSchedule: "OFF - วันหยุด",
    effectiveDate: "15/02/2024",
    lastModified: "Thanaset\n01/01/24 10:00",
  },
];
